module.exports = __webpack_public_path__ + "21b422bb5157ff232f1f7e138d28e3ad.svg";


//////////////////
// WEBPACK FOOTER
// ./src/client/images/Investments-logo.svg
// module id = 978
// module chunks = 0